import styled from 'styled-components'

export const FloatingButtonWrap = styled.div`
    position: fixed;
    
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    max-width: 430px;
    overflow: auto;
    z-index: 999;
    
`
export const FloatingImg = styled.img`
  cursor: pointer;
  display: block;
  zoom: 2;
      
`